import { Panel } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { getThemeByType } from 'utils/common';
import Enums from 'utils/EnumsManager';
import { Table, Toolbar, Topbar } from '../components/index';

const ObjectList = ({ objectType }) => {
  const theme = getThemeByType(objectType);

  return (
    <Fragment>
      <Topbar objectType={objectType} />
      <Panel
        panelClasses={`${theme}-theme-panel`}
        contentClasses="pb-xlg"
      >
        <Toolbar
          theme={theme}
          objectType={objectType}
        />
        <Table
          key={objectType}
          theme={theme}
          objectType={objectType}
        />
      </Panel>
    </Fragment>
  );
};


ObjectList.propTypes = {
  objectType: PropTypes.oneOf(Enums.ObjectTypesInArray).isRequired,
};

export default ObjectList;



// WEBPACK FOOTER //
// ./src/views/ObjectList/container/index.jsx